import isFilterableParam from './isFilterableParam';
import stripFilterPrefix from './stripFilterPrefix';
import {NO_FILTER_QUERY_PARAMS} from '../constants';

/**
 * Given an object that contains search params,
 * this function should only return amasty
 * related / filterable search params.
 * @param {Object} filters
 */
const sanitizeQueryFilters = filters =>
  Object.keys(filters).reduce((acc, curr) => {
    if (!isFilterableParam(curr) && !NO_FILTER_QUERY_PARAMS.includes(curr)) {
      return acc;
    }

    return {
      ...acc,
      [stripFilterPrefix(curr)]: filters[curr],
    };
  }, {});

export default sanitizeQueryFilters;
